// extracted by mini-css-extract-plugin
module.exports = {"primary":"#0d4f9d","secondary":"#ff1744","appFrame":"Layout_appFrame__3-2NK","mainContent":"Layout_mainContent__37FhD"};